import { Link } from "@tanstack/react-router";

import {
  LEGAL_DOCUMENTS,
  type LegalDocumentContent,
} from "./legalContent";

// Public, unauthenticated legal page (L1-U3, ADR 0028 D4). Rendered as a
// top-level route so the documents are reachable before sign-in and from the
// acceptance gate's "read" links.
export function LegalDocumentPage({ content }: { content: LegalDocumentContent }) {
  return (
    <main className="min-h-screen bg-surface">
      <section className="mx-auto max-w-3xl px-4 py-10 space-y-6">
        <header className="space-y-2">
          <Link to="/" className="text-sm text-primary underline">
            Back to home
          </Link>
          <h1 className="font-display text-3xl font-medium tracking-tight text-on-surface">
            {content.title}
          </h1>
        </header>
        <div className="space-y-6 text-sm leading-relaxed text-on-surface-variant">
          {content.body}
        </div>
      </section>
    </main>
  );
}

export function TermsPage() {
  return <LegalDocumentPage content={LEGAL_DOCUMENTS.terms} />;
}

export function PrivacyPage() {
  return <LegalDocumentPage content={LEGAL_DOCUMENTS.privacy} />;
}

export function DisclaimerPage() {
  return <LegalDocumentPage content={LEGAL_DOCUMENTS.disclaimer} />;
}
